import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStreetView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_54_323)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_54_323",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 0H0V20H20V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_54_323)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.99951 1C10.5962 1 11.1685 1.23696 11.5905 1.65875C12.0125 2.08054 12.2495 2.65262 12.2495 3.24911C12.2495 3.84561 12.0125 4.41769 11.5905 4.83947C11.1685 5.26127 10.5962 5.49823 9.99951 5.49823C9.40278 5.49823 8.83048 5.26127 8.40853 4.83947C7.98656 4.41769 7.74951 3.84561 7.74951 3.24911C7.74951 2.65262 7.98656 2.08054 8.40853 1.65875C8.83048 1.23696 9.40278 1 9.99951 1ZM8.87451 6.62279H11.1245C12.3655 6.62279 13.3745 7.63138 13.3745 8.8719V10.5587C13.3745 11.1808 12.8717 11.6833 12.2495 11.6833H12.1862L11.796 15.18C11.7327 15.7492 11.2511 16.1815 10.678 16.1815H9.31748C8.74444 16.1815 8.26279 15.7492 8.19951 15.18L7.80927 11.6833H7.74599C7.12373 11.6833 6.62099 11.1808 6.62099 10.5587V8.8719C6.62099 7.63138 7.62998 6.62279 8.87099 6.62279H8.87451ZM15.4979 15.0641C14.932 14.9164 14.2745 14.7969 13.5502 14.7055L13.7366 13.0293C14.5346 13.1312 15.2729 13.2646 15.9198 13.4333C16.7073 13.6372 17.4175 13.9008 17.9519 14.2522C18.4686 14.5896 18.9995 15.1273 18.9995 15.9039C18.9995 16.6806 18.4686 17.2183 17.9519 17.5556C17.4175 17.9036 16.7038 18.1705 15.9198 18.3744C14.3342 18.7855 12.2179 19 9.99951 19C7.78116 19 5.66474 18.7855 4.0792 18.3744C3.2917 18.1636 2.58154 17.9 2.04717 17.5521C1.53037 17.2147 0.999512 16.677 0.999512 15.9004C0.999512 15.1238 1.53037 14.5861 2.04717 14.2486C2.58154 13.9008 3.29521 13.6337 4.0792 13.4298C4.72958 13.2612 5.46787 13.1277 6.2624 13.0258L6.44873 14.7055C5.72451 14.7969 5.06708 14.9199 4.50107 15.0641C2.51123 15.5771 2.51123 16.2202 4.50107 16.7332C5.90381 17.0952 7.86904 17.3026 9.99951 17.3026C12.13 17.3026 14.0952 17.0952 15.4979 16.7332C17.4877 16.2202 17.4877 15.5771 15.4979 15.0641Z",
				fill: "black"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_54_323",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgStreetView;
